// UI copy only: reservation values, customer names and API enums stay unchanged.
export const reservationGroupMessages = {
  "Add Group Extras": "Añadir extras al grupo",
  "Add extras to selected reservations and pending nights only": "Añade extras solo a las reservas elegidas y a sus noches pendientes",
  "The group rate is locked from the first check-in.": "La tarifa del grupo está bloqueada desde la primera entrada.",
  "Set the rate of each new room without changing the existing group rate.": "Configura la tarifa de cada habitación nueva sin modificar la tarifa del grupo existente.",
  "Add these rooms to the group?": "¿Añadir estas habitaciones al grupo?",
  "Only the {p0} new reservations will be added. Existing reservations will remain unchanged.": "Solo se añadirán las {p0} reservas nuevas. Las reservas existentes permanecerán sin cambios.",
  "New rooms": "Habitaciones nuevas",
  "New rooms only · Existing reservations remain unchanged.": "Solo habitaciones nuevas · Las reservas existentes no se modifican.",
  "You are adding rooms to an existing group. Its current reservations, agreed prices and payments will not be changed.": "Estás añadiendo habitaciones a un grupo existente. Sus reservas actuales, precios pactados y pagos no se modificarán.",
  "Could not complete this action. Please review the reservation and try again.": "No se ha podido completar esta acción. Revisa la reserva e inténtalo de nuevo.",
  "No valid room rates. Review the selected dates, occupancy and room category.": "No hay tarifas válidas. Revisa las fechas, la ocupación y la categoría de habitación.",
  "Reference: {code}": "Referencia: {code}",
  " (optional)": " (opcional)",
  "none": "ninguna",
  "manual": "manual",
  "system": "sistema",
  " · system": " · automático",
  " · protected": " · protegido",
  " · voidable": " · anulable",
  " · voided": " · anulado",
  "adults": "adultos",
  "pending nights": "noches pendientes",
  "active rooms": "habitaciones activas",
  "delivery": "envío",
  "deliveries": "envíos",
  "room #{p0}": "habitación n.º {p0}",
  "{p0} waived": "{p0} exonerados",
  " · {p0} change{p1}": " · Cambios: {p0}",
  "{p0} night{p1}": "Noches: {p0}",
  "Meal Plan": "Régimen alimenticio",
  "Smoking Preference": "Preferencia de fumador",
  "Payment Collect": "Gestión del cobro",
  "Payment Type": "Tipo de pago",
  "OTA Commission": "Comisión de la agencia en línea",
  "Commission": "Comisión",
  "Guest name": "Nombre del huésped",
  "Guarantee": "Garantía",
  "Card": "Tarjeta",
  "Policies": "Políticas",
  "Cancellation Policy": "Política de cancelación",
  "Deposit Policy": "Política de depósito",
  "Children and Extra Bed Policy": "Política de niños y camas supletorias",
  "Taxes": "Impuestos",
  "Services": "Servicios",
  "Rate Plan": "Plan de tarifas",
  "Rate Plan Code": "Código del plan de tarifas",
  "Room Type Code": "Código del tipo de habitación",
  "Room Remarks": "Observaciones de la habitación",
  "Bed Preferences": "Preferencias de cama",
  "Listing Base Price": "Precio base del anuncio",
  "Total Paid Amount": "Importe total pagado",
  "Transient Occupancy Tax Paid Amount": "Importe pagado de tasa turística",
  "Listing Security Price": "Depósito de seguridad del anuncio",
  "Listing Cancellation Payout": "Abono por cancelación del anuncio",
  "Listing Cancellation Host Fee": "Comisión del anfitrión por cancelación",
  "Occupancy Tax Amount Paid To Host": "Tasa turística pagada al anfitrión",
  "Check In Date": "Fecha de entrada",
  "Check Out Date": "Fecha de salida",
  "Reservation Status": "Estado de reserva",
  "Total Price": "Precio total",
  "Room Price": "Precio de habitación",
  "Base Price": "Precio base",
  "Effective Price": "Precio efectivo",
  "Room Category Id": "Categoría de habitación",
  "Room Rate Id": "Tarifa de habitación",
  "Rate Price Id": "Precio de tarifa",
  "Room Id": "Habitación",
  "Special Requests": "Peticiones especiales",
  "Check In Time": "Hora de entrada",
  "Check Out Time": "Hora de salida",
  "Total Extras": "Total de extras",
  "main_guest": "Huésped principal",
  "accompanying": "Acompañante",
  "accompanying_guest": "Huésped acompañante",
  "booker": "Titular de la reserva",
  "No valid room rates ({p0}): {p1}": "No hay tarifas de habitación válidas ({p0}): {p1}",
  "No valid room rates: {p0}": "No hay tarifas de habitación válidas: {p0}",
  "No valid room rates ({p0}).": "No hay tarifas de habitación válidas ({p0}).",
  "No valid room rates. Details: {p0}": "No hay tarifas de habitación válidas. Detalles: {p0}",
  "Booked: {p0}": "Reservada: {p0}",
  "Assigned: {p0}": "Asignada: {p0}",
  "Rate price #{p0}": "Precio de tarifa n.º {p0}",
  "Customer #{p0}": "Cliente n.º {p0}",
  "Night {p0}": "Noche {p0}",
  "{p0}: no availability": "{p0}: sin disponibilidad",
  "No rooms were copied.\n": "No se ha copiado ninguna habitación.\n",
  "Skipped: {p0}\n": "Omitidas: {p0}\n",
  "\nDetails:\n{p0}": "\nDetalles:\n{p0}",
  "Copied: {p0}\n": "Copiadas: {p0}\n",
  "Copied: {p0}": "Copiadas: {p0}",
  "No rooms were copied.\nSkipped: {p0}": "No se ha copiado ninguna habitación.\nOmitidas: {p0}",
  "{p0} has been updated. Prices were recalculated from the selected room rate.": "Se ha actualizado {p0}. Los precios se han recalculado a partir de la tarifa de habitación seleccionada.",
  "Reservation #{p0}": "Reserva n.º {p0}",
  "reservation #{p0}": "reserva n.º {p0}",
  "{p0} was upgraded for the selected nights. Room price was preserved and the separate upgrade charge is {p1}.": "Se ha mejorado {p0} para las noches seleccionadas. Se ha conservado el precio de habitación y el cargo independiente por mejora es de {p1}.",
  "{p0} was updated for the selected nights. Room price difference: {p1}.": "Se ha actualizado {p0} para las noches seleccionadas. Diferencia de precio de habitación: {p1}.",
  "Rate #{p0}": "Tarifa n.º {p0}",
  "{p0} has been updated.": "Se ha actualizado {p0}.",
  "{p0} extras have been updated.": "Se han actualizado los extras de {p0}.",
  "{p0} has been cancelled{p1}": "Se ha cancelado {p0}{p1}",
  "{p0} has been marked as No Show{p1}": "Se ha marcado {p0} como no presentada{p1}",
  "Early departure charge for {p0}": "Cargo por salida anticipada del {p0}",
  "{p0} has been checked out early{p1}": "Se ha registrado la salida anticipada de {p0}{p1}",
  "This room category allows up to {p0} adult{p1}.": "Número máximo de adultos en esta categoría: {p0}.",
  "This room category allows up to {p0} child{p1}.": "Número máximo de niños en esta categoría: {p0}.",
  "This room category allows up to {p0} total guest{p1} across adults and children.": "Número máximo de huéspedes en esta categoría, entre adultos y niños: {p0}.",
  "The selected adults count is not valid for this stay. Available adults: {p0}.": "El número de adultos seleccionado no es válido para esta estancia. Opciones disponibles: {p0}.",
  "The selected children count is not valid for this stay. Available children: {p0}.": "El número de niños seleccionado no es válido para esta estancia. Opciones disponibles: {p0}.",
  "The previous room category is not available for the selected occupancy. Available categories: {p0}.": "La categoría anterior no está disponible para esta ocupación. Categorías disponibles: {p0}.",
  "The previous room rate is not valid for the selected occupancy. Available rates: {p0}.{p1}": "La tarifa anterior no es válida para esta ocupación. Tarifas disponibles: {p0}.{p1}",
  "The previous adults count is not valid for the selected dates. Available adults: {p0}.": "El número anterior de adultos no es válido para estas fechas. Opciones disponibles: {p0}.",
  "The previous children count is not valid for the selected dates. Available children: {p0}.": "El número anterior de niños no es válido para estas fechas. Opciones disponibles: {p0}.",
  "The previous room category is not available for the selected dates. Available categories: {p0}.": "La categoría anterior no está disponible para estas fechas. Categorías disponibles: {p0}.",
  "The previous room rate is not valid for the selected dates. Available rates: {p0}.{p1}": "La tarifa anterior no es válida para estas fechas. Tarifas disponibles: {p0}.{p1}",
  "Please fill the required check-in data before completing check-in: {p0}.": "Completa los datos obligatorios antes de registrar la entrada: {p0}.",
  "{p0} has been checked in.": "Se ha registrado la entrada de {p0}.",
  "{p0} has been moved back to Confirmed.": "Se ha restablecido {p0} como confirmada.",
  "{p0} has been checked out.": "Se ha registrado la salida de {p0}.",
  "This reservation cannot be reinstated because these stay dates are no longer available: {p0}.": "No se puede restablecer esta reserva porque estas fechas ya no están disponibles: {p0}.",
  "The reservation was reinstated successfully, but {p0} is no longer free. Pilcore kept it as a suggested room so you can assign another one when needed.": "La reserva se ha restablecido, pero {p0} ya no está libre. Pilcore la ha conservado como habitación sugerida para que puedas asignar otra cuando lo necesites.",
  "Room {p0} - {p1}": "Habitación {p0} - {p1}",
  "Room {p0}": "Habitación {p0}",
  "Select a definitive room from {p0} to {p1}.": "Selecciona una habitación definitiva del {p0} al {p1}.",
  "Could not find draft nightly prices for {p0}.": "No se han encontrado precios por noche del borrador para {p0}.",
  "{p0} posted as early departure charges": "{p0} contabilizados como cargos por salida anticipada",
  "{p0} has been checked out early. {p1}": "Se ha registrado la salida anticipada de {p0}. {p1}",
  "Add {p0} {p1}": "Añadir {p0} {p1}",
  "Reservation confirmation sent to {p0}{p1}.": "Confirmación de reserva enviada a {p0}{p1}.",
  "Email {p0}": "Correo electrónico {p0}",
  "Whole group · {p0}": "Todo el grupo · {p0}",
  "Room {p0} · {p1}": "Habitación {p0} · {p1}",
  "Res. #{p0}": "Reserva n.º {p0}",
  "This will confirm all {p0} reservations in this group.": "Se confirmarán las {p0} reservas de este grupo.",
  "Category #{p0}": "Categoría n.º {p0}",
  "Status: {p0}": "Estado: {p0}",
  "Status {p0}": "Estado {p0}",
  " Conflicting reservation{p0}: {p1}.": " Reservas con fechas coincidentes: {p1}.",
  "The assignment request failed{p0}.": "La solicitud de asignación ha fallado{p0}.",
  " with HTTP {p0}": " con HTTP {p0}",
  "Group #{p0}": "Grupo n.º {p0}",
  " · Max {p0}": " · Máx. {p0}",
  " · Stay {p0}": " · Estancia {p0}",
  "This will update {p0} to No Show and remove it from active check-in workflows. No no-show charge will be applied.": "Se marcará {p0} como no presentada y se retirará de las entradas pendientes. No se aplicará ningún cargo por no presentación.",
  "This will move {p0} back to Confirmed and clear the arrival timestamp. This is only available on the check-in date.": "Se restablecerá {p0} como confirmada y se borrará la hora de llegada. Solo está disponible el día de entrada.",
  "This will move {p0} to Checked Out and record the departure time.": "Se registrará la salida de {p0} y se guardará la hora de salida.",
  "This will restore {p0} and consume availability again if the stay dates are still free.": "Se restablecerá {p0} y volverá a consumir disponibilidad si las fechas de estancia siguen libres.",
  "This will move {p0} back to Confirmed so it returns to the active check-in workflow.": "Se restablecerá {p0} como confirmada para que vuelva a aparecer en las entradas pendientes.",
  "Group {p0}": "Grupo {p0}",
  "Additional recipient {p0}": "Destinatario adicional {p0}",
  "No room rates available.": "No hay tarifas de habitación disponibles.",
  "Unknown date": "Fecha desconocida",
  "Yes": "Sí",
  "No": "No",
  "Change": "Cambio",
  "Rate price unlinked": "Precio de tarifa sin vincular",
  "Main guest": "Huésped principal",
  "Child": "Menor",
  "Accompanying guest": "Huésped acompañante",
  "System": "Sistema",
  "Status": "Estado",
  "Check-in": "Entrada",
  "Check-out": "Salida",
  "Adults": "Adultos",
  "Children": "Niños",
  "Room category": "Categoría de habitación",
  "Room rate": "Tarifa de habitación",
  "Room": "Habitación",
  "Rooms": "Habitaciones",
  "Room total": "Total de la habitación",
  "Floor": "Planta",
  "Bed type": "Tipo de cama",
  "View": "Vistas",
  "No special requests for this reservation.": "Esta reserva no tiene peticiones especiales.",
  "Special requests": "Peticiones especiales",
  "Guest requests by room": "Peticiones de los huéspedes por habitación",
  "Close special requests": "Cerrar peticiones especiales",
  "No special requests for this group.": "Este grupo no tiene peticiones especiales.",
  "Modify Stay Dates": "Modificar fechas de estancia",
  "Change Room Category Assigned": "Cambiar categoría de habitación asignada",
  "Assign Room Number": "Asignar número de habitación",
  "Change Number of Adults/Children": "Cambiar número de adultos y niños",
  "Change Room Rate or Price": "Cambiar tarifa o precio de habitación",
  "Manage Extras": "Gestionar extras",
  "Manage Charges": "Gestionar cargos",
  "Payments": "Pagos",
  "Send Confirmation": "Enviar confirmación",
  "Room Move": "Cambio de habitación",
  "Room Category Move": "Cambio de categoría de habitación",
  "Modify Stay": "Modificar estancia",
  "Guests & Occupancy": "Huéspedes y ocupación",
  "Price Adjustment": "Ajuste de precio",
  "Registration Form": "Ficha de registro",
  "Discard Update": "Descartar cambios",
  "Discard Draft": "Descartar borrador",
  "Select Suggested Room": "Seleccionar habitación sugerida",
  "Unassign room": "Quitar número de habitación",
  "Keep the room category and leave the room number unassigned.": "Mantiene la categoría y deja el número de habitación sin asignar.",
  "Review available and occupied rooms before applying the suggestion.": "Revisa las habitaciones disponibles y ocupadas antes de aplicar la sugerencia.",
  "Manual change not allowed": "Cambio manual no permitido",
  "Error copying info.": "No se ha podido copiar la información.",
  "You do not have permission to view reservation payments.": "No tienes permiso para ver los pagos de la reserva.",
  "Failed to load saved cards.": "No se han podido cargar las tarjetas guardadas.",
  "Reservation history could not be loaded.": "No se ha podido cargar el historial de la reserva.",
  "The selected reservation is not part of this reservation group.": "La reserva seleccionada no pertenece a este grupo.",
  "Rates & Prices": "Tarifas y precios",
  "Rates & Prices is available from the confirmed reservation view.": "Tarifas y precios está disponible en la vista de reservas confirmadas.",
  "The requested reservation is not valid.": "La reserva solicitada no es válida.",
  "The requested reservation is not part of this reservation group.": "La reserva solicitada no pertenece a este grupo.",
  "Rates & Prices could not be opened. Refresh the reservation and try again.": "No se ha podido abrir Tarifas y precios. Actualiza la reserva e inténtalo de nuevo.",
  "Check In": "Registrar entrada",
  "Mark as No Show": "Marcar como no presentado",
  "Reverse Check-In": "Revertir entrada",
  "Check-Out": "Registrar salida",
  "Cancel Reservation": "Cancelar reserva",
  "Revert No Show": "Revertir no presentado",
  "Reinstate": "Restablecer",
  "In-House Actions": "Acciones durante la estancia",
  "Post-Stay Actions": "Acciones tras la estancia",
  "Reservation Actions": "Acciones de la reserva",
  "Modify Stay is available from the confirmed reservation view.": "Modificar estancia está disponible en la vista de reservas confirmadas.",
  "Modify Stay could not be completed.": "No se ha podido modificar la estancia.",
  "The current room is not available for the modified stay. Use Room Move before changing these dates.": "La habitación actual no está disponible para la nueva estancia. Usa Cambio de habitación antes de modificar estas fechas.",
  "Enter the reason for changing this OTA reservation.": "Indica el motivo del cambio en esta reserva de una agencia en línea.",
  "Stay modified": "Estancia modificada",
  "Guests & Occupancy is available from the confirmed reservation view.": "Huéspedes y ocupación está disponible en la vista de reservas confirmadas.",
  "Guests & occupancy updated": "Huéspedes y ocupación actualizados",
  "Room & Category": "Habitación y categoría",
  "Room & Category is available from the confirmed reservation view.": "Habitación y categoría está disponible en la vista de reservas confirmadas.",
  "There are no future stay nights available for a Room & Category move.": "No quedan noches de estancia para cambiar la habitación y la categoría.",
  "The reservation needs valid stay dates before changing room category.": "La reserva necesita fechas de estancia válidas antes de cambiar la categoría de habitación.",
  "The reservation needs a valid adults count before changing room category.": "La reserva necesita un número válido de adultos antes de cambiar la categoría de habitación.",
  "No room categories are available for the selected nights.": "No hay categorías de habitación disponibles para las noches seleccionadas.",
  "Room Category Move options could not be loaded.": "No se han podido cargar las opciones de cambio de categoría.",
  "Select a room category and pricing option before reviewing the price.": "Selecciona una categoría de habitación y una opción de tarifa antes de revisar el precio.",
  "The end date must be later than the first affected night.": "La fecha final debe ser posterior a la primera noche afectada.",
  "Room Category Move options could not be loaded for these dates.": "No se han podido cargar las opciones de cambio de categoría para estas fechas.",
  "No permitted category-change option is available.": "No hay opciones permitidas de cambio de categoría.",
  "No upgrade rate is configured for this category route.": "No hay ninguna tarifa de mejora configurada para este cambio de categoría.",
  "Upgrade rate could not be applied.": "No se ha podido aplicar la tarifa de mejora.",
  "Upgrade rate could not be removed.": "No se ha podido quitar la tarifa de mejora.",
  "Select a room category before selecting a room rate.": "Selecciona una categoría de habitación antes de seleccionar una tarifa.",
  "Remove the upgrade rate before choosing a new room rate.": "Quita la tarifa de mejora antes de elegir una nueva tarifa de habitación.",
  "Room Category Move price preview could not be completed.": "No se ha podido calcular el precio del cambio de categoría.",
  "Select a room category and room rate before applying an override.": "Selecciona una categoría y una tarifa de habitación antes de aplicar un ajuste manual.",
  "Room-price overrides are only available for a normal category change.": "Los ajustes manuales de precio solo están disponibles para un cambio de categoría normal.",
  "Override could not be removed.": "No se ha podido quitar el ajuste manual.",
  "The selected room must be available for every affected night.": "La habitación seleccionada debe estar disponible todas las noches afectadas.",
  "Select a room category and complete the price review before confirming.": "Selecciona una categoría de habitación y revisa el precio antes de confirmar.",
  "Complete the category and price selection, then choose an available room before confirming.": "Completa la selección de categoría y precio y elige una habitación disponible antes de confirmar.",
  "Complete the category and price selection before confirming.": "Completa la selección de categoría y precio antes de confirmar.",
  "Choose a different category, rate, room or price before confirming.": "Elige una categoría, tarifa, habitación o precio diferente antes de confirmar.",
  "Room upgrade completed": "Mejora de habitación completada",
  "Room category change completed": "Cambio de categoría completado",
  "Room Category Move could not be completed.": "No se ha podido completar el cambio de categoría.",
  "Select a room category and room rate before confirming.": "Selecciona una categoría y una tarifa de habitación antes de confirmar.",
  "Choose a different category, rate or room before confirming.": "Elige una categoría, tarifa o habitación diferente antes de confirmar.",
  "Room & category updated": "Habitación y categoría actualizadas",
  "This reservation needs a standard room rate and valid stay dates before prices can be edited.": "Esta reserva necesita una tarifa de habitación estándar y fechas de estancia válidas antes de editar los precios.",
  "The reservation needs valid stay dates before editing rates or prices.": "La reserva necesita fechas de estancia válidas antes de editar las tarifas o los precios.",
  "Rates & Prices cannot edit a Group Rate yet. Use the full update flow for this reservation.": "Tarifas y precios todavía no permite editar una tarifa de grupo. Utiliza la edición completa de esta reserva.",
  "The reservation needs a standard room rate before prices can be edited.": "La reserva necesita una tarifa de habitación estándar antes de editar los precios.",
  "Could not create the rates-and-prices draft.": "No se ha podido crear el borrador de tarifas y precios.",
  "Could not find the reservation inside the rates-and-prices draft.": "No se ha encontrado la reserva en el borrador de tarifas y precios.",
  "Prepare the price change before confirming.": "Prepara el cambio de precio antes de confirmar.",
  "Choose a different rate, apply an override, or remove the current override before confirming.": "Elige otra tarifa, aplica un ajuste manual o quita el ajuste actual antes de confirmar.",
  "Rates & prices updated": "Tarifas y precios actualizados",
  "Price adjustment applied": "Ajuste de precio aplicado",
  "Manage Extras is available from the confirmed reservation view.": "Gestionar extras está disponible en la vista de reservas confirmadas.",
  "Select a room rate and room price before managing extras.": "Selecciona una tarifa y un precio de habitación antes de gestionar extras.",
  "Could not create the extras draft.": "No se ha podido crear el borrador de extras.",
  "Could not find the reservation inside the extras draft.": "No se ha encontrado la reserva en el borrador de extras.",
  "Manage Extras could not be opened.": "No se ha podido abrir la gestión de extras.",
  "Could not save extras because the draft was not prepared.": "No se han podido guardar los extras porque el borrador no estaba preparado.",
  "Extras updated": "Extras actualizados",
  "Manage Extras could not be saved.": "No se han podido guardar los extras.",
  "You do not have permission to manage reservation charges.": "No tienes permiso para gestionar los cargos de la reserva.",
  "Manage Charges is available from the confirmed reservation view.": "Gestionar cargos está disponible en la vista de reservas confirmadas.",
  "The protected charge type for this action is not available in Settings.": "El tipo de cargo protegido para esta acción no está disponible en Configuración.",
  "Manage Charges could not be opened.": "No se ha podido abrir la gestión de cargos.",
  "Choose a charge type before saving.": "Elige un tipo de cargo antes de guardar.",
  "This action requires its protected charge type.": "Esta acción requiere su tipo de cargo protegido.",
  "Enter a valid quantity and amount.": "Introduce una cantidad y un importe válidos.",
  "{currency} charge amounts accept whole units only.": "Los importes de cargos en {currency} solo admiten unidades enteras.",
  "{currency} charge amounts accept up to {decimals} decimal places.": "Los importes de cargos en {currency} admiten un máximo de {decimals} decimales.",
  "Choose a stay date within this reservation stay.": "Elige una fecha dentro de la estancia de esta reserva.",
  "Cancellation Charge": "Cargo por cancelación",
  "Cancellation charge": "Cargo por cancelación",
  "Reason for cancellation": "Motivo de cancelación",
  "Charge note": "Nota del cargo",
  "Internal note for the charge": "Nota interna del cargo",
  "Reservation cancelled": "Reserva cancelada",
  "No-Show Charge": "Cargo por no presentación",
  "No-show charge": "Cargo por no presentación",
  "No-show note": "Nota de no presentación",
  "Reason or internal note": "Motivo o nota interna",
  "Reservation marked No Show": "Reserva marcada como no presentada",
  "Early Check-Out Charge": "Cargo por salida anticipada",
  "Early departure charge": "Cargo por salida anticipada",
  "Early check-out note": "Nota de salida anticipada",
  "Check-out completed": "Salida registrada",
  "Cancellation charge waived": "Cargo por cancelación exonerado",
  "Cancellation penalty applied": "Penalización por cancelación aplicada",
  " without a cancellation charge.": " sin cargo por cancelación.",
  " with a cancellation charge.": " con cargo por cancelación.",
  " without a no-show charge.": " sin cargo por no presentación.",
  " with a no-show charge.": " con cargo por no presentación.",
  " without an early departure charge.": " sin cargo por salida anticipada.",
  " with an early departure charge.": " con cargo por salida anticipada.",
  "Enter a cancellation reason before continuing.": "Indica el motivo de cancelación antes de continuar.",
  "The reservation action could not be completed.": "No se ha podido completar la acción de la reserva.",
  "Reservation charge could not be saved.": "No se ha podido guardar el cargo de la reserva.",
  "Reservation charge could not be voided.": "No se ha podido anular el cargo de la reserva.",
  "Adults must be at least 1.": "Debe haber al menos un adulto.",
  "Children cannot be negative.": "El número de niños no puede ser negativo.",
  "Choose a different occupancy before applying this action.": "Elige una ocupación diferente antes de aplicar esta acción.",
  "The reservation needs valid stay dates before changing occupancy.": "La reserva necesita fechas de estancia válidas antes de cambiar la ocupación.",
  "The reservation needs a room category before changing occupancy.": "La reserva necesita una categoría de habitación antes de cambiar la ocupación.",
  "Guests & Occupancy cannot recalculate a Group Rate yet. Use the full update flow for this reservation.": "Huéspedes y ocupación todavía no puede recalcular una tarifa de grupo. Utiliza la edición completa de esta reserva.",
  "The reservation needs a standard room rate before Guests & Occupancy can recalculate prices.": "La reserva necesita una tarifa estándar para recalcular los precios al cambiar la ocupación.",
  "Could not create the guests-and-occupancy draft.": "No se ha podido crear el borrador de huéspedes y ocupación.",
  "Could not find the reservation inside the guests-and-occupancy draft.": "No se ha encontrado la reserva en el borrador de huéspedes y ocupación.",
  "No availability for the selected occupancy.": "No hay disponibilidad para la ocupación seleccionada.",
  "Check-out must be after check-in.": "La salida debe ser posterior a la entrada.",
  "Check-in is locked for in-house reservations. Modify Stay can only change check-out.": "La entrada está bloqueada para las reservas con huéspedes alojados. Solo puedes modificar la fecha de salida.",
  "Choose different dates before applying Modify Stay.": "Elige otras fechas antes de modificar la estancia.",
  "The reservation needs a valid adults count before Modify Stay.": "La reserva necesita un número válido de adultos antes de modificar la estancia.",
  "The reservation needs a room category before Modify Stay.": "La reserva necesita una categoría de habitación antes de modificar la estancia.",
  "Modify Stay cannot recalculate a Group Rate yet. Use the full update flow for this reservation.": "Modificar estancia todavía no puede recalcular una tarifa de grupo. Utiliza la edición completa de esta reserva.",
  "The reservation needs a standard room rate before Modify Stay can recalculate prices.": "La reserva necesita una tarifa estándar para recalcular los precios al modificar la estancia.",
  "Could not create the modify-stay draft.": "No se ha podido crear el borrador de modificación de estancia.",
  "Could not find the reservation inside the modify-stay draft.": "No se ha encontrado la reserva en el borrador de modificación de estancia.",
  "No availability for the selected dates.": "No hay disponibilidad para las fechas seleccionadas.",
  "This reservation action is disabled.": "Esta acción de la reserva está desactivada.",
  "Reservation action": "Acción de la reserva",
  "This action is ready in the menu. Its workflow will be connected next.": "Esta acción todavía no está disponible.",
  "Room Number": "Número de habitación",
  "Stay dates": "Fechas de estancia",
  "Occupancy": "Ocupación",
  "Company booker data": "Datos de la empresa titular",
  "Company booker contact name": "Nombre del contacto de la empresa titular",
  "Booker": "Titular de la reserva",
  "Booker data": "Datos del titular",
  "Main guest data": "Datos del huésped principal",
  "Accompanying guests": "Huéspedes acompañantes",
  "Accompanying guest data": "Datos de los acompañantes",
  "Child guests": "Huéspedes menores",
  "Child guest data": "Datos de los menores",
  "Full payment": "Pago completo",
  "Required check-in data missing": "Faltan datos obligatorios para la entrada",
  "Check-in completed": "Entrada registrada",
  "Could not complete check-in": "No se ha podido registrar la entrada",
  "Could not complete this check-in.": "No se ha podido registrar esta entrada.",
  "Failed to cancel room reservation.": "No se ha podido cancelar la reserva de habitación.",
  "Error marking reservation as No Show.": "No se ha podido marcar la reserva como no presentada.",
  "Error reverting reservation from No Show.": "No se ha podido revertir el estado de no presentado.",
  "Reverse check-in not available": "No se puede revertir la entrada",
  "Check-in can only be reversed on the same date it was completed.": "La entrada solo se puede revertir el mismo día en que se registró.",
  "Check-in reversed": "Entrada revertida",
  "Could not reverse check-in": "No se ha podido revertir la entrada",
  "Could not reverse this check-in.": "No se ha podido revertir esta entrada.",
  "Check-out not available": "La salida no está disponible",
  "This check-in can still be reversed today. Check-out becomes available from the following day.": "Esta entrada todavía se puede revertir hoy. La salida estará disponible a partir del día siguiente.",
  "Only checked-in reservations can be checked out.": "Solo se puede registrar la salida de reservas con la entrada registrada.",
  "Could not complete check-out": "No se ha podido registrar la salida",
  "Could not complete this check-out.": "No se ha podido registrar esta salida.",
  "This reservation could not be reinstated right now.": "No se ha podido restablecer esta reserva en este momento.",
  "Reservation reinstated with suggested room": "Reserva restablecida con habitación sugerida",
  "Reinstatement unavailable": "Restablecimiento no disponible",
  "Could not reinstate reservation": "No se ha podido restablecer la reserva",
  "No access": "Sin acceso",
  "Loading...": "Cargando...",
  "Reservation details · Solo consulta": "Detalle de reserva · Solo consulta",
  "Cancelled reservation details": "Detalle de reserva cancelada",
  "Confirmed reservation details": "Detalle de reserva confirmada",
  "Draft reservation details": "Detalle del borrador de reserva",
  "Enter a valid time.": "Introduce una hora válida.",
  "The time could not be saved.": "No se ha podido guardar la hora.",
  "Missing reservation target or customer id.": "Falta la reserva de destino o el identificador del cliente.",
  "Missing reservation target or guest role.": "Falta la reserva de destino o el tipo de huésped.",
  "Missing customer id.": "Falta el identificador del cliente.",
  "Room not assigned": "Habitación sin asignar",
  "Room number": "Número de habitación",
  "Select a room category before assigning a room number.": "Selecciona una categoría antes de asignar un número de habitación.",
  "Reservation dates are required before assigning a room number.": "Indica las fechas de la reserva antes de asignar un número de habitación.",
  "There are no future stay nights available for a room move.": "No quedan noches de estancia para cambiar de habitación.",
  "Select an available room in the assigned room category.": "Selecciona una habitación disponible de la categoría asignada.",
  "Error fetching available rooms.": "No se han podido obtener las habitaciones disponibles.",
  "Select a valid room move window inside the remaining stay.": "Selecciona un intervalo válido dentro de la estancia restante para cambiar de habitación.",
  "Select a different room for the room move.": "Selecciona otra habitación para realizar el cambio.",
  "Checked-in reservations need a definitive available room, not a suggestion.": "Las reservas con entrada registrada necesitan una habitación disponible definitiva, no una sugerencia.",
  "Select a valid room move window before choosing a room.": "Selecciona un intervalo válido de cambio antes de elegir una habitación.",
  "Error saving room.": "No se ha podido guardar la habitación.",
  "Failed to load nightly breakdown.": "No se ha podido cargar el desglose por noche.",
  "Early check-out room price release": "Liberación del precio de habitación por salida anticipada",
  "Preserved existing override": "Se conserva el ajuste manual existente",
  "Early check-out charge conversion is not available for reservations using Group Rate.": "La conversión de cargos por salida anticipada no está disponible para reservas con tarifa de grupo.",
  "Could not create the early check-out draft.": "No se ha podido crear el borrador de salida anticipada.",
  "Could not find this reservation inside the early check-out draft.": "No se ha encontrado esta reserva en el borrador de salida anticipada.",
  "No nightly price changes were prepared for this early check-out.": "No se han preparado cambios en los precios por noche para esta salida anticipada.",
  "Early check-out not available": "Salida anticipada no disponible",
  "Early check-out charge conversion is not available for Group Rate reservations yet.": "La conversión de cargos por salida anticipada todavía no está disponible para reservas con tarifa de grupo.",
  "Could not prepare early check-out": "No se ha podido preparar la salida anticipada",
  "Could not prepare the early check-out charge.": "No se ha podido preparar el cargo por salida anticipada.",
  "unconsumed room nights were removed from the room price": "las noches no consumidas se han descontado del precio de la habitación",
  "Could not complete this early check-out.": "No se ha podido completar esta salida anticipada.",
  "This reservation group has no active rooms to confirm.": "Este grupo no tiene habitaciones activas que confirmar.",
  "Group cancellation unavailable": "Cancelación de grupo no disponible",
  "You do not have permission to add rooms to this group.": "No tienes permiso para añadir habitaciones a este grupo.",
  "Error adding rooms to group.": "No se han podido añadir habitaciones al grupo.",
  "Add rooms": "Añadir habitaciones",
  "Could not create the reservation update draft.": "No se ha podido crear el borrador de actualización de la reserva.",
  "Error adding room to group.": "No se ha podido añadir la habitación al grupo.",
  "Group extras": "Extras del grupo",
  "You do not have permission to manage reservation extras.": "No tienes permiso para gestionar los extras de la reserva.",
  "Could not open group extras.": "No se han podido abrir los extras del grupo.",
  "Group special rate": "Tarifa especial del grupo",
  "You do not have permission to override reservation rates.": "No tienes permiso para ajustar las tarifas de la reserva.",
  "Could not open group special rate.": "No se ha podido abrir la tarifa especial del grupo.",
  "Could not save the group update.": "No se han podido guardar los cambios del grupo.",
  "Group extras updated": "Extras del grupo actualizados",
  "Group extras were applied and saved to the reservation group.": "Los extras se han aplicado y guardado en el grupo de reservas.",
  "This manual reservation change is disabled.": "Este cambio manual de la reserva está desactivado.",
  "Add rooms to this reservation group": "Añadir habitaciones a este grupo de reservas",
  "No permission to add rooms to reservation groups": "Sin permiso para añadir habitaciones a grupos de reservas",
  "Copy Info": "Copiar información",
  "Copy setup from one room to another": "Copiar la configuración de una habitación a otra",
  "Needs at least two rooms with room rate": "Se necesitan al menos dos habitaciones con tarifa asignada",
  "Manage Group Extras": "Gestionar extras del grupo",
  "Manage extras for every room in the group": "Gestionar los extras de todas las habitaciones del grupo",
  "No permission to manage reservation extras": "Sin permiso para gestionar los extras de la reserva",
  "Apply Group Special Rate": "Aplicar tarifa especial al grupo",
  "Apply a negotiated price to the group": "Aplicar un precio negociado al grupo",
  "No permission to override reservation rates": "Sin permiso para ajustar las tarifas de la reserva",
  "Preparing...": "Preparando...",
  "Manage Payments": "Gestionar pagos",
  "No payment access": "Sin acceso a pagos",
  "Checking saved cards": "Comprobando tarjetas guardadas",
  "Saved card on file": "Hay una tarjeta guardada",
  "No saved card on file": "No hay tarjetas guardadas",
  "Fill Registration Form": "Completar ficha de registro",
  "Sending...": "Enviando...",
  "Cancel Reservations": "Cancelar reservas",
  "At least one email is required to send the booking confirmation.": "Se necesita al menos un correo electrónico para enviar la confirmación de reserva.",
  "Failed to send reservation confirmation.": "No se ha podido enviar la confirmación de reserva.",
  "Enter a note explaining why the OTA reservation price is being changed.": "Escribe una nota explicando el cambio de precio de la reserva de la agencia en línea.",
  "Group special rate applied": "Tarifa especial del grupo aplicada",
  "The special rate was applied and saved to the reservation group.": "La tarifa especial se ha aplicado y guardado en el grupo de reservas.",
  "Error applying special rate (draft).": "No se ha podido aplicar la tarifa especial al borrador.",
  "Reservation Group": "Grupo de reservas",
  "| Review room setup, guests and pricing.": "| Revisa las habitaciones, los huéspedes y los precios.",
  "Active Rooms": "Habitaciones activas",
  "Cancelled": "Cancelada",
  "Group Actions": "Acciones del grupo",
  "Group Account": "Cuenta del grupo",
  "Close": "Cerrar",
  "Save": "Guardar",
  "Discard": "Descartar",
  "Company · Contact:": "Empresa · Contacto:",
  "Not provided": "No indicado",
  "No booker assigned.": "No hay titular de la reserva asignado.",
  "Edit": "Editar",
  "Error removing booker.": "No se ha podido quitar al titular de la reserva.",
  "Remove": "Quitar",
  "No booker assigned": "Sin titular de la reserva asignado",
  "No reservation found in this group.": "No se han encontrado reservas en este grupo.",
  "Select": "Seleccionar",
  "Add Booker": "Añadir titular de la reserva",
  "Summary": "Resumen",
  "Sales": "Ventas",
  "Extras": "Extras",
  "Charges": "Cargos",
  "Totals": "Totales",
  "Total": "Total",
  "Paid": "Pagado",
  "Balance": "Saldo",
  "more": "más",
  "Whole group": "Todo el grupo",
  "Comments": "Comentarios",
  "Add / view comments": "Añadir o ver comentarios",
  "Guest": "Huésped",
  "No comments yet. Click to add one.": "Todavía no hay comentarios. Pulsa para añadir uno.",
  "Confirm this reservation?": "¿Confirmar esta reserva?",
  "Confirm these reservations?": "¿Confirmar estas reservas?",
  "This will confirm the reservation and make it active.": "La reserva se confirmará y quedará activa.",
  "Saving...": "Guardando...",
  "Confirm": "Confirmar",
  "Cancel": "Cancelar",
  "Cannot confirm: some rooms have no room rate. Delete them or assign a room rate.": "No se puede confirmar: algunas habitaciones no tienen tarifa. Elimínalas o asígnales una tarifa.",
  "Cannot confirm: no booker is assigned. Assign a booker before confirming.": "No se puede confirmar: no hay titular de la reserva. Asigna uno antes de confirmar.",
  "Failed to confirm reservation group.": "No se ha podido confirmar el grupo de reservas.",
  "Reservation Update": "Actualización de reserva",
  "Reservation Draft": "Borrador de reserva",
  "Discard this update draft?": "¿Descartar este borrador de cambios?",
  "Discard this draft reservation group?": "¿Descartar este borrador de grupo de reservas?",
  "This will discard the pending update only. The original reservation group will remain unchanged.": "Solo se descartarán los cambios pendientes. El grupo de reservas original no se modificará.",
  "This will discard the draft reservation group. No confirmed reservation will be deleted.": "Se descartará el borrador del grupo. No se eliminará ninguna reserva confirmada.",
  "Discarding...": "Descartando...",
  "Failed to discard update draft.": "No se ha podido descartar el borrador de cambios.",
  "Rooms to Add:": "Habitaciones que añadir:",
  "Add Room": "Añadir habitación",
  "Copy From:": "Copiar desde:",
  "Select reservation": "Seleccionar reserva",
  "Copy To:": "Copiar a:",
  "All": "Todas",
  "Copying...": "Copiando...",
  "Copy": "Copiar",
  "Manage group extras": "Gestionar extras del grupo",
  "Apply special group rate (draft)": "Aplicar tarifa especial al grupo (borrador)",
  "Draft": "Borrador",
  "Unknown": "Desconocido",
  "Hide reservation details": "Ocultar detalles de la reserva",
  "Show reservation details": "Mostrar detalles de la reserva",
  "Main guest pending assignment": "Huésped principal pendiente de asignar",
  "Main guest pending": "Huésped principal pendiente",
  "Edit reservation stay data": "Editar datos de estancia de la reserva",
  "Actions": "Acciones",
  "Open reservation account": "Abrir cuenta de la reserva",
  "Account": "Cuenta",
  "View original state and change history": "Ver estado original e historial de cambios",
  "History": "Historial",
  "Stay": "Estancia",
  "nights": "noches",
  "adults ·": "adultos ·",
  "children": "niños",
  "Assigned category": "Categoría asignada",
  " · Split stay": " · Estancia dividida",
  "Booked:": "Reservada:",
  "Change room number": "Cambiar número de habitación",
  "Show previous room details": "Mostrar detalles de la habitación anterior",
  "Previous room": "Habitación anterior",
  "Show next room details": "Mostrar detalles de la habitación siguiente",
  "Next room": "Habitación siguiente",
  "Floor:": "Planta:",
  "Bed type:": "Tipo de cama:",
  "View:": "Vistas:",
  "Amount": "Importe",
  "· Extras": "· Extras",
  "· Charges": "· Cargos",
  "Removed reservations cannot be edited": "No se pueden editar las reservas eliminadas",
  "Edit this room reservation": "Editar esta reserva de habitación",
  "Room already removed from this group draft": "Esta habitación ya se ha quitado del borrador del grupo",
  "Remove this room from the group": "Quitar esta habitación del grupo",
  "Removed": "Eliminada",
  "Removing...": "Eliminando...",
  "You cannot delete the last room": "No puedes eliminar la última habitación",
  "Remove this room reservation": "Eliminar esta reserva de habitación",
  "Delete this room reservation?": "¿Eliminar esta reserva de habitación?",
  "Error deleting room reservation.": "No se ha podido eliminar la reserva de habitación.",
  "Guest assignment and status": "Asignación y estado de huéspedes",
  "Please, select data for reservation first": "Primero, completa los datos de la reserva",
  "Main Guest": "Huésped principal",
  "Select main guest": "Seleccionar huésped principal",
  "Add main guest": "Añadir huésped principal",
  "Edit main guest": "Editar huésped principal",
  "Remove main guest": "Quitar huésped principal",
  "Error removing main guest.": "No se ha podido quitar al huésped principal.",
  "Main guest pending to select": "Huésped principal pendiente de seleccionar",
  "The booker cannot be assigned to this stay": "No se puede asignar al titular a esta estancia",
  "Exact reason": "Motivo exacto",
  "This customer is already assigned to another active reservation with overlapping dates.": "Este cliente ya está asignado a otra reserva activa con fechas coincidentes.",
  "How to solve it": "Cómo resolverlo",
  "Review the conflicting stay. Remove this customer from that reservation, correct either stay's dates, or close/cancel the conflicting reservation if that is operationally correct. Then try again.": "Revisa la estancia que coincide. Quita al cliente de esa reserva, corrige las fechas de alguna de las estancias o cierra/cancela la reserva en conflicto si corresponde. Después, inténtalo de nuevo.",
  "The booker could not be assigned": "No se ha podido asignar al titular",
  "Check that the reservation and booker still exist, reload this group, and retry. If it persists, report reservation #": "Comprueba que la reserva y el titular siguen existiendo, recarga el grupo e inténtalo de nuevo. Si persiste, indica la reserva n.º ",
  "and the reason shown above.": "y el motivo indicado arriba.",
  "Booker assigned — refresh required": "Titular asignado: actualiza la vista",
  "What happened": "Qué ha ocurrido",
  "The booker was assigned successfully, but Pilcore could not refresh the guest panel:": "El titular se ha asignado, pero Pilcore no ha podido actualizar el panel de huéspedes:",
  "unknown refresh error": "error de actualización desconocido",
  "Reload this reservation group. Do not assign the booker again.": "Recarga este grupo de reservas. No vuelvas a asignar al titular.",
  "Booker assigned — required fields not verified": "Titular asignado: campos obligatorios sin verificar",
  "Hotel settings are temporarily unavailable.": "La configuración del hotel no está disponible temporalmente.",
  "Reload the reservation and review the main guest's required fields manually. The booker assignment itself has already been saved.": "Recarga la reserva y revisa manualmente los campos obligatorios del huésped principal. La asignación del titular ya se ha guardado.",
  "Assign booker as main guest": "Asignar al titular como huésped principal",
  "Click here if it is same as booker": "Pulsa aquí si es el titular de la reserva",
  "Accompanying": "Acompañantes",
  "Select accompanying guest": "Seleccionar acompañante",
  "Add accompanying guest": "Añadir acompañante",
  "Edit accompanying guest": "Editar acompañante",
  "Remove accompanying guest": "Quitar acompañante",
  "Error removing accompanying guest.": "No se ha podido quitar al acompañante.",
  "Accompanying guest pending to select": "Acompañante pendiente de seleccionar",
  "Select child": "Seleccionar menor",
  "Add child": "Añadir menor",
  "Edit child": "Editar menor",
  "Remove child": "Quitar menor",
  "Error removing child.": "No se ha podido quitar al menor.",
  "Children guest pending to select": "Menor pendiente de seleccionar",
  "Check-in / Check-out": "Entrada / Salida",
  "Click to change the check-in time": "Pulsa para cambiar la hora de entrada",
  "Check-in time": "Hora de entrada",
  "Click to change the check-out time": "Pulsa para cambiar la hora de salida",
  "Check-out time": "Hora de salida",
  "Saving time...": "Guardando hora...",
  "Select a time; it will be saved when you leave the field.": "Selecciona una hora; se guardará al salir del campo.",
  "Add / view comments for this room": "Añadir o ver comentarios de esta habitación",
  "No comments for this room.": "Esta habitación no tiene comentarios.",
  "Nightly Breakdown": "Desglose por noche",
  "Loading nightly prices...": "Cargando precios por noche...",
  "Category pending": "Categoría pendiente",
  "· Assigned:": "· Asignada:",
  "· Room": "· Habitación",
  "Room total from nights": "Total de habitación por noches",
  "No nightly breakdown available for this reservation.": "Esta reserva no tiene desglose por noche disponible.",
  "No room reservations yet.": "Todavía no hay reservas de habitación.",
  "Accommodation": "Alojamiento",
  "Current room": "Habitación actual",
  "Move from": "Cambiar desde",
  "Move until": "Cambiar hasta",
  "Loading rooms...": "Cargando habitaciones...",
  "No rooms found.": "No se han encontrado habitaciones.",
  "Available": "Disponible",
  "Occupied / Blocked": "Ocupadas / Bloqueadas",
  "You cannot change the booker for this group.": "No puedes cambiar al titular de este grupo.",
  "Select a company.": "Selecciona una empresa.",
  "Select a person.": "Selecciona una persona.",
  "Failed to assign main guest.": "No se ha podido asignar al huésped principal.",
  "Failed to assign child.": "No se ha podido asignar al menor.",
  "Close group actions": "Cerrar acciones del grupo",
  "Add": "Añadir",
  "Rooms to add": "Habitaciones que añadir",
  "Increase room count": "Aumentar número de habitaciones",
  "Decrease room count": "Reducir número de habitaciones",
  "This action is not available right now.": "Esta acción no está disponible en este momento.",
  "This icon means the action is disabled by the manual modification permissions in Settings → Reservation Settings.": "Este icono indica que la acción está desactivada por los permisos de modificación manual en Configuración → Configuración de reservas.",
  "Copy room information": "Copiar información de habitación",
  "Close copy info": "Cerrar copia de información",
  "Copy room setup": "Copiar configuración de habitación",
  "Choose one source room and copy its setup into another room or the whole group.": "Elige una habitación de origen y copia su configuración a otra habitación o a todo el grupo.",
  "Copy From": "Copiar desde",
  "Copy To": "Copiar a",
  "Reservation change history": "Historial de cambios de la reserva",
  "Reservation audit": "Registro de la reserva",
  "Original state and change history": "Estado original e historial de cambios",
  "Close reservation history": "Cerrar historial de reserva",
  "Reservation audit views": "Vistas del registro de reserva",
  "Audit detail": "Detalle del registro",
  "Change list": "Lista de cambios",
  "Loading reservation history...": "Cargando historial de reserva...",
  "Try again": "Reintentar",
  "No version history is available for this reservation yet.": "Esta reserva todavía no tiene historial de versiones.",
  "Field changes": "Cambios en los campos",
  "Oldest change first": "Cambios más antiguos primero",
  "This reservation has an initial version but no later changes.": "Esta reserva tiene una versión inicial, pero no cambios posteriores.",
  "Date ↑": "Fecha ↑",
  "Reservation": "Reserva",
  "Field": "Campo",
  "Old value": "Valor anterior",
  "New value": "Valor nuevo",
  "Changed by": "Modificado por",
  "Original vs current": "Original y actual",
  "No changes": "Sin cambios",
  "No changes in these fields.": "Sin cambios en estos campos.",
  "No changes in guests.": "Sin cambios en los huéspedes.",
  "No changes in nightly terms.": "Sin cambios en las condiciones por noche.",
  "Last changed": "Última modificación",
  "Original": "Original",
  "Current": "Actual",
  "Original vs current guests": "Huéspedes originales y actuales",
  "Identity, role and contact snapshot": "Identidad, función y datos de contacto",
  "Original vs current nightly terms": "Condiciones por noche originales y actuales",
  "Category, rate, effective price and rate price link": "Categoría, tarifa, precio efectivo y vínculo al precio de tarifa",
  "Night": "Noche",
  "Timeline": "Cronología",
  "Newest change first": "Cambios más recientes primero",
  "Reason": "Motivo",
  "No reason recorded.": "No se ha registrado ningún motivo.",
  "Nightly detail ·": "Detalle por noche ·",
  "night": "noche",
  "Reservation Studio": "Gestión de reservas",
  "Close actions": "Cerrar acciones",
  "No category": "Sin categoría",
  "No rate": "Sin tarifa",
  "Room and Category": "Habitación y categoría",
  "Review Room & Category": "Revisar habitación y categoría",
  "Close room and category": "Cerrar habitación y categoría",
  "Selected nights:": "Noches seleccionadas:",
  "to": "a",
  "Current:": "Actual:",
  "No room": "Sin habitación",
  "First affected night": "Primera noche afectada",
  "End of change": "Fin del cambio",
  "Loading accommodation options...": "Cargando opciones de alojamiento...",
  "Room Category": "Categoría de habitación",
  "No categories available.": "No hay categorías disponibles.",
  "· Children": "· Niños",
  "Room Rate": "Tarifa de habitación",
  "Select a room category first.": "Selecciona primero una categoría de habitación.",
  "Keep booked room rate": "Mantener la tarifa reservada",
  "Loading room rates...": "Cargando tarifas de habitación...",
  "No available room was found for every affected night.": "No se ha encontrado una habitación disponible para todas las noches afectadas.",
  "No room selected. It can be assigned later.": "No se ha seleccionado ninguna habitación. Puedes asignarla más adelante.",
  "Clear room": "Quitar habitación",
  "Price Review": "Revisión de precio",
  "Current room price": "Precio actual de habitación",
  "New room price": "Nuevo precio de habitación",
  "Remove upgrade rate": "Quitar tarifa de mejora",
  "Remove override": "Quitar ajuste manual",
  "Override": "Ajuste manual",
  "Apply upgrade rate": "Aplicar tarifa de mejora",
  "Upgrade charge": "Cargo por mejora",
  "Total difference": "Diferencia total",
  "Reason for changing this OTA reservation": "Motivo del cambio de esta reserva de agencia en línea",
  "Required": "Obligatorio",
  "For example: Upgrade requested by the guest": "Por ejemplo: mejora solicitada por el huésped",
  "This note will be saved in the reservation history with your user and the change date.": "Esta nota se guardará en el historial de la reserva con tu usuario y la fecha del cambio.",
  "Upgrade rate applied. The configured upgrade charge will be added separately when you confirm.": "Tarifa de mejora aplicada. El cargo configurado se añadirá por separado al confirmar.",
  "The selected nights will use the new booked and assigned category, room rate and reviewed room price. Past nights remain locked.": "Las noches seleccionadas utilizarán las nuevas categorías reservada y asignada, la tarifa y el precio revisado. Las noches pasadas seguirán bloqueadas.",
  "Select a category and room rate to review the new room price.": "Selecciona una categoría y una tarifa de habitación para revisar el nuevo precio.",
  "Working...": "Procesando...",
  "Confirm Room & Category": "Confirmar habitación y categoría",
  "Rates and Prices": "Tarifas y precios",
  "Close rates and prices": "Cerrar tarifas y precios",
  "Stay:": "Estancia:",
  "Invalid dates": "Fechas no válidas",
  "Loading rates and prices...": "Cargando tarifas y precios...",
  "Overrides": "Ajustes manuales",
  "Applied": "Aplicado",
  "None": "Ninguno",
  "Override active": "Ajuste manual activo",
  "Base nightly prices": "Precios base por noche",
  "The draft price includes manual nightly override rules.": "El precio del borrador incluye reglas de ajuste manual por noche.",
  "Use the existing override options when this reservation needs a manual price adjustment.": "Utiliza las opciones de ajuste disponibles cuando esta reserva necesite un ajuste manual de precio.",
  "Selected rate base": "Base de la tarifa seleccionada",
  "Override impact": "Impacto del ajuste manual",
  "Final room price": "Precio final de habitación",
  "Difference": "Diferencia",
  "For example: Price adjustment agreed with the guest": "Por ejemplo: ajuste de precio acordado con el huésped",
  "Confirming will update the reservation room rate, overrides and room price.": "Al confirmar se actualizarán la tarifa de habitación, los ajustes manuales y el precio de la reserva.",
  "Select a different room rate or apply an override before confirming.": "Selecciona otra tarifa de habitación o aplica un ajuste manual antes de confirmar.",
  "Close manage extras": "Cerrar gestión de extras",
  "Preparing extras...": "Preparando extras...",
  "Close manage charges": "Cerrar gestión de cargos",
  "Loading reservation charges...": "Cargando cargos de la reserva...",
  "Posted charges:": "Cargos contabilizados:",
  "Voided:": "Anulados:",
  "Total charges:": "Total de cargos:",
  "Edit manual charge": "Editar cargo manual",
  "Add manual charge": "Añadir cargo manual",
  "Why is this reservation being cancelled?": "¿Por qué se cancela esta reserva?",
  "Charge type": "Tipo de cargo",
  "Choose charge type": "Elegir tipo de cargo",
  "Charge type unavailable": "Tipo de cargo no disponible",
  "Service date": "Fecha del servicio",
  "Stay date": "Fecha de estancia",
  "Not linked to a stay date": "Sin vincular a una fecha de estancia",
  "Quantity": "Cantidad",
  "Unit amount": "Importe unitario",
  "Description": "Descripción",
  "Internal charge note": "Nota interna del cargo",
  "Cancel edit": "Cancelar edición",
  "Waive Charge": "Exonerar cargo",
  "Processing...": "Procesando...",
  "Save Charge": "Guardar cargo",
  "Add Charge": "Añadir cargo",
  "Reservation charges": "Cargos de la reserva",
  "Reservation charge": "Cargo de la reserva",
  "Early check-out": "Salida anticipada",
  "Voiding...": "Anulando...",
  "Void": "Anular",
  "No reservation charges yet.": "Esta reserva todavía no tiene cargos.",
  "Review Price Change": "Revisar cambio de precio",
  "Close modify stay": "Cerrar modificación de estancia",
  "Current stay:": "Estancia actual:",
  "New stay:": "Nueva estancia:",
  "Change reason": "Motivo del cambio",
  "Required for OTA reservations": "Obligatorio en reservas de agencias en línea",
  "Why is the PMS stay being changed?": "¿Por qué se modifica la estancia en el PMS?",
  "Confirming will update the reservation check-out and the recalculated room price.": "Al confirmar se actualizarán la salida de la reserva y el precio recalculado de habitación.",
  "Confirming will update the reservation with the new stay dates and the recalculated room price.": "Al confirmar se actualizarán las fechas de estancia y el precio recalculado de habitación.",
  "Check-in is locked because the guest is already in house. Pilcore will keep the existing occupancy, category, room rate and room number when they are still valid. Prices will be recalculated.": "La entrada está bloqueada porque el huésped ya está alojado. Pilcore conservará la ocupación, categoría, tarifa y número de habitación actuales cuando sigan siendo válidos. Se recalcularán los precios.",
  "Pilcore will keep the existing occupancy, category, room rate and room number when they are still valid. Prices will be recalculated.": "Pilcore conservará la ocupación, categoría, tarifa y número de habitación actuales cuando sigan siendo válidos. Se recalcularán los precios.",
  "Back": "Volver",
  "Confirming...": "Confirmando...",
  "Applying...": "Aplicando...",
  "Confirm Modify Stay": "Confirmar modificación de estancia",
  "Apply Modify Stay": "Aplicar modificación de estancia",
  "Guests and Occupancy": "Huéspedes y ocupación",
  "Close guests and occupancy": "Cerrar huéspedes y ocupación",
  "adult": "adulto",
  "child": "niño",
  "New:": "Nueva:",
  "Why is the OTA reservation occupancy being changed?": "¿Por qué se modifica la ocupación de esta reserva de agencia en línea?",
  "Confirming will update the reservation occupancy and the recalculated room price.": "Al confirmar se actualizarán la ocupación de la reserva y el precio recalculado de habitación.",
  "Pilcore will keep the existing dates, category, room rate and room number when they are still valid. Prices will be recalculated.": "Pilcore conservará las fechas, categoría, tarifa y número de habitación actuales cuando sigan siendo válidos. Se recalcularán los precios.",
  "Confirm Guests & Occupancy": "Confirmar huéspedes y ocupación",
  "Apply Guests & Occupancy": "Aplicar huéspedes y ocupación",
  "Early check-out review": "Revisión de salida anticipada",
  "Early Check-Out": "Salida anticipada",
  "Close early check-out": "Cerrar salida anticipada",
  "Departure:": "Salida:",
  "Original check-out:": "Salida original:",
  "pending night": "noche pendiente",
  "Loading pending nights...": "Cargando noches pendientes...",
  "Early departure value": "Importe de salida anticipada",
  "Unconsumed room value": "Importe de habitación no consumido",
  "Waived amount": "Importe exonerado",
  "Kept as charge": "Conservado como cargo",
  "Pending nights": "Noches pendientes",
  "charge ·": "con cargo ·",
  "waived": "exoneradas",
  "Charge all": "Cobrar todas",
  "Waive all": "Exonerar todas",
  " · override included": " · ajuste manual incluido",
  "Charge": "Cobrar",
  "Waive": "Exonerar",
  "Consumed nights": "Noches consumidas",
  "Adjust previous nights": "Ajustar noches anteriores",
  "Open the existing override flow if already-consumed nights need a manual price adjustment.": "Abre el ajuste manual si necesitas modificar el precio de noches ya consumidas.",
  "This reservation uses Group Rate, so early check-out charge conversion is blocked for now.": "Esta reserva utiliza una tarifa de grupo; por ahora no se pueden convertir los cargos por salida anticipada.",
  "Completing check-out removes pending nights from room price. Charged nights are posted as protected Reservation Charges.": "Al registrar la salida, las noches pendientes se descontarán del precio de la habitación. Las noches con cargo se contabilizarán como cargos protegidos de la reserva.",
  "Checking out...": "Registrando salida...",
  "Complete Check-Out": "Registrar salida",
  "Understood": "Entendido",
  "Mark reservation as No Show?": "¿Marcar la reserva como no presentada?",
  "No Show": "No presentado",
  "Reverse check-in?": "¿Revertir la entrada?",
  "Reversing...": "Revirtiendo...",
  "Complete check-out?": "¿Registrar la salida?",
  "Reinstate reservation?": "¿Restablecer la reserva?",
  "Restoring...": "Restableciendo...",
  "Revert No Show?": "¿Revertir el estado de no presentado?",
  "Reservation update": "Actualización de reserva",
  "Saving reservation…": "Guardando reserva…",
  "Cancel reservation group": "Cancelar grupo de reservas",
  "Failed to cancel reservation group.": "No se ha podido cancelar el grupo de reservas.",
  "Confirm cancellation": "Confirmar cancelación",
  "Send Reservation Confirmation": "Enviar confirmación de reserva",
  "Review the recipient list before sending the PDF confirmation to the guest.": "Revisa los destinatarios antes de enviar la confirmación en PDF al huésped.",
  "Recipients": "Destinatarios",
  "The booker email is prefilled when available. You can edit it or add more recipients.": "El correo del titular se completa automáticamente si está disponible. Puedes editarlo o añadir destinatarios.",
  "Some recipients already received a confirmation for this group.": "Algunos destinatarios ya han recibido una confirmación de este grupo.",
  "a Palantir user": "un usuario de Pilcore",
  "last received it on": "lo recibió por última vez el",
  "by": "por",
  "Primary recipient": "Destinatario principal",
  "Last sent on": "Último envío el",
  "to this address.": "a esta dirección.",
  "Remove this email": "Quitar este correo",
  "Add another email": "Añadir otro correo",
  "Sent history": "Historial de envíos",
  "Check previous confirmation emails and the recipient list before sending again.": "Revisa las confirmaciones anteriores y los destinatarios antes de volver a enviar.",
  "Palantir user": "Usuario de Pilcore",
  "Email": "Correo electrónico",
  "Sent by": "Enviado por",
  "Manual recipients": "Destinatarios añadidos manualmente",
  "Booker email": "Correo del titular",
  "active room": "habitación activa",
  "No confirmation emails have been sent yet for this reservation group.": "Todavía no se han enviado correos de confirmación para este grupo de reservas.",
  "Send confirmation": "Enviar confirmación",
  "Cancel reservation": "Cancelar reserva",
  "Cancel room reservation": "Cancelar reserva de habitación",
  "Cancelling...": "Cancelando...",
};
